<mat-card appearance="filled" class="information-card">
  <div class="header row">
    <h2>Group Information</h2>

    <button matRipple class="button" [matMenuTriggerFor]="menu">
      <fa-icon [icon]="['fas', 'ellipsis-vertical']" size="lg"></fa-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <fa-icon [icon]="['fas', 'pause']" size="sm"></fa-icon>
        <span>Suspend group</span>
      </button>

      <button mat-menu-item>
        <fa-icon [icon]="['fas', 'pen']" size="sm"></fa-icon>
        <span>Rename Main</span>
      </button>

      <button mat-menu-item (click)="changePlan.emit()">
        <img class="custom-icon" src="assets/icons/plans-icon.svg" alt="Plans" />
        <span>Change plan</span>
      </button>

      <button mat-menu-item>
        <fa-icon [icon]="['fas', 'user-gear']" size="sm"></fa-icon>
        <span>Change owner</span>
      </button>

      <button mat-menu-item>
        <fa-icon [icon]="['fas', 'fingerprint']" size="sm"></fa-icon>
        <span>Change Hostbill ID</span>
      </button>

      <button mat-menu-item class="red">
        <fa-icon [icon]="['fas', 'trash']" size="sm"></fa-icon>
        <span>Terminate Group</span>
      </button>
    </mat-menu>
  </div>
  <div class="info-row row">
    @for (info of groupInfo; track $index) {
      <div class="info">
        <div class="label">{{ info.label }}</div>
        <div
          class="text"
          [ngClass]="info.class?.()"
          [matTooltip]="info.tooltip?.()"
          [routerLink]="info.routerLink?.(groupData())"
        >
          {{ info.text(groupData()) }}
          @if (info.class?.()?.includes('link')) {
            <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" size="sm"></fa-icon>
          }
        </div>
      </div>
    }
  </div>
  <div class="buttons-row row">
    <button matButton="filled" (click)="migrateGroup.emit()">
      <fa-icon [icon]="['fas', 'arrow-right-arrow-left']" size="sm"></fa-icon>
      Migrate Group
    </button>
    <button matButton="outlined">
      <fa-icon [icon]="['fas', 'plus']" size="sm"></fa-icon>
      Create Terminated Backup
    </button>
    <button matButton="outlined">
      <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" size="sm"></fa-icon>
      Open Hostbill
    </button>
    <button
      matButton="outlined"
      [cdkCopyToClipboard]="'This is the text I want to copy!'"
      (cdkCopyToClipboardCopied)="onCopied($event)"
    >
      <fa-icon [icon]="['fas', 'copy']" size="sm"></fa-icon>
      Copy SSH login
    </button>
  </div>
</mat-card>
